import noUiSlider from 'nouislider/dist/nouislider'

export function initRangeSlider(el) {
    const slider = el.querySelector('[data-range-slider]');
    const inputFrom = el.querySelector('[data-range-input-from]');
    const inputTo = el.querySelector('[data-range-input-to]');

    noUiSlider.create(slider, {
        start: [inputFrom.value || 0, inputTo.value || 100],
        range: {
            'min': [Number(slider.dataset.rangeSliderMin)],
            'max': [Number(slider.dataset.rangeSliderMax)],
        },
        connect: [false, true, false],
        step: 1
    });

    slider.noUiSlider.on('slide', ([from, to]) => {
        inputFrom.value = Number(from).toFixed(0);
        inputTo.value = Number(to).toFixed(0);
    })
}
